module.exports = __webpack_public_path__ + "static/media/see-store-step.7609fb67.png";